import {Component, OnInit, ViewChild, Output} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { EventEmitter } from '@angular/core';
import { NgbdModalContent } from '../alert-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserData } from '../model/UserData';

export interface Program {
  code: string;
  coach: string;
  title: string;
  startdate: string;
  enddate: string;
  programtime: string;
  program_id: string;
}
@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.css']
})
export class ProgramComponent implements OnInit {
  displayedColumns: string[] = ['code', 'coach', 'title', 'startdate', 'enddate', 'programtime'];
  dataSource = new MatTableDataSource<Program>();
  data: LogsData[];
  programcode;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
  );
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService,
    private cookie: CookieService,
    private router : Router,
    private modalService: NgbModal,
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var Program_DATA : Program[] = [];

    this._bkoffService.getOngoingProgram().then((res) => {
      this.data = res;
      console.log(res);
      this.data.forEach(element => {
        if (element.code != null) {
          Program_DATA.push({program_id:element.program_id, code: element.code, coach: element.coachname, title: element.title, startdate: element.startdate, enddate:element.enddate, programtime:element.programtime});
        } else {
          Program_DATA.push({program_id:element.program_id, code: element.code, coach: element.coachname, title: element.title, startdate: element.startdate, enddate:element.enddate, programtime:element.programtime});
        }
      });  
      this.dataSource = new MatTableDataSource<Program>(Program_DATA);
      this.dataSource.sort = this.sort;
    });
  }

  cellClicked(element) {
    console.log(element.code + ' cell clicked');
    this.programcode = element.code;
    this.cookie.set("program", this.programcode);
    this.cookie.set('program_id', element.program_id);
    this.router.navigateByUrl('/preprogram');
  }
}